import { PropsWithChildren } from "react";

import { cn } from "@/common/utils/css.utils";

type NewLabelProps = PropsWithChildren<{
  className?: string;
  /** Decorative next to a label that already says what it is. */
  "aria-hidden"?: boolean;
}>;

/**
 * The standard "Nieuw" label for new features (WHO-5937): design system 09.2
 * Label, Attention / Dark / Rounded-full / Small. Pass positioning through
 * `className`; the text comes from the caller's Lokalise key.
 */
export const NewLabel = ({
  children,
  className,
  "aria-hidden": ariaHidden,
}: NewLabelProps) => (
  <span
    aria-hidden={ariaHidden}
    data-testid="new-label"
    className={cn(
      "inline-block shrink-0 whitespace-nowrap rounded-full bg-attention-500 px-2 py-0 font-title text-sm font-bold leading-5 text-white",
      className
    )}
  >
    {children}
  </span>
);
